
let $FORM
let $CATEGORYBUTTON
let $CATEGORYREMOVEBUTTTON

function addCategory() {
    var categoryIndex = $('#dynamic-category').children().length
    var categoryDataAttr = 'data-category-index="' + categoryIndex + '"'

    var $categoryNode = '<div class="ps-form-submission__category" id="category-index-' + categoryIndex + '">' +
        '<div class="ps-form-submission__category-header"><h2>Title</h2></div>' +
        '<div class="ps-form-submission__category-content">' +
        '<label>Category:</label>' +
        '<input type="text" class="category-title" name="Form.Categories[' + categoryIndex + '].Title" required placeholder="Starter, Main, Dessert" />' +
        '<label>Additional Information:</label>' +
        '<input type="text" name="Form.Categories[' + categoryIndex + '].AdditionalInformation"  />' +
        '<div class="items-container"></div>' +
        '<button type="button" class="addItem ps-button" ' + categoryDataAttr + '" id="add-item-btn-' + categoryIndex + '">Add Item</button>' +
        '<button type="button" class="removeItem ps-button" ' + categoryDataAttr + '">Remove Item</button>' +
        '</div>' +
        '</div>'

    $('#dynamic-category').append($categoryNode)
    //$('#add-item-btn-' + categoryIndex).click()

    $('#dynamic-category').children(':not(:last-child)').addClass('ps-form-submission__category-closed')
    $('#dynamic-category').children().last().find('.category-title').focus()

    categoryIndex++;
}

function removeCategory() {
    $('#dynamic-category').children().last().remove()
    $('#dynamic-category').children().last().removeClass('ps-form-submission__category-closed')
    $('#dynamic-category').children().last().find('.category-title').focus()
}

function addItem() {
    var categoryIndex = $(this).data("categoryIndex")
    var index = ($(this)).siblings('div.items-container').children().length
    var prefix = 'Form.Categories[' + categoryIndex + '].Items[' + index + '].'
    var $node = '<div class="ps-form-submission__item">' +
        '<label>Title:</label> ' +
        '<input type="text" name="' + prefix + 'Title" required /><br/>' +
        ' <label>Price: </label> ' +
        '<input type="number" step="any" name="' + prefix + 'Price"  required number /><br/>' +
        ' <label>Additional Information: </label> ' +
        '<input type="text" name="' + prefix + 'Info" />' +
        '</div>'
    var categoryContainer = $('#category-index-' + categoryIndex).find('.items-container')
    categoryContainer.append($node)
}

function removeItem() {
    var items = ($(this)).siblings('div.items-container').children()
    items.last().remove()
}

function updateTitle() {
    $(this).parent().parent().find('.ps-form-submission__category-header h2').text($(this).val())
}

function toggleCategory() {
    $(this).parent().toggleClass('ps-form-submission__category-closed')
}

function formSubmit() {
    if ($FORM.valid()) {
        $('.ps-loader').show()
    }
}

export default class MerchantFormSubmission {
    constructor() {
        $FORM = $('form')
        $CATEGORYBUTTON = $('#addCategory')
        $CATEGORYREMOVEBUTTTON = $('#removeCategory')
    }

    init() {
        $CATEGORYBUTTON.on('click', addCategory)
        $CATEGORYREMOVEBUTTTON.on('click', removeCategory)
        $(document).on('click', '.addItem', addItem)
        $(document).on('click', '.removeItem', removeItem)
        $(document).on('click', '.ps-form-submission__category-header', toggleCategory)
        $(document).on('change', '.category-title', updateTitle)
        $FORM.on('submit', formSubmit)
    }
}



// WEBPACK FOOTER //
// ./js/modules/MerchantSubmission.js